import moment from 'moment';

import { TimeCard } from '../../data';

export const momentIsFilled = (date: string, timeCardData?: TimeCard): boolean => {
    if (timeCardData && moment(date).isSame(new Date(), 'day')) {
        const now = moment().format('HH:mm');
        return timeCardData.timeBlocks.some((timeBlock) => {
            return (
                timeBlock.from &&
                moment(timeBlock.from, 'HH:mm:ss').format('HH:mm') <= now &&
                (!timeBlock.to || moment(timeBlock.to, 'HH:mm:ss').format('HH:mm') > now)
            );
        });
    }

    return false;
};